// create analytics button name from url path + children text (spaces removed)
export default function analyticsButtonName(children: any): string {
  return `${window.location.pathname.replace(/\/$/, "_")}__${children
    .toString()
    .replace(/\s/g, "_")
    .replace(/[^a-zA-Z0-9_]/g, "")}`;
}
